import type { TTranscriptionRouteOutcome } from '../types/TTranscriptionRouteOutcome';

export const getTranscriptRouteOutcome = (status: string | undefined): TTranscriptionRouteOutcome =>
  status === 'error' ? 'response-failed' : status === 'completed' ? 'response-received' : 'awaiting-response';
